import { IPredictedLineupsDetail } from '@sky-it-livedata/livedata-sports-design-system';

export const hydrateImageUrl = (params: { url: string; hash: string }): string => {
  const { url, hash } = params;

  return url.replace('{hash}', hash);
};

export const transformPlayersInFormationImages = (params: {
  args: IPredictedLineupsDetail;
  headshothash?: string;
}): IPredictedLineupsDetail => {
  const { args, headshothash = '' } = params;

  const hydratedArgs: IPredictedLineupsDetail = JSON.parse(JSON.stringify(args || {}));

  if (args?.home?.playersInFormation?.length) {
    hydratedArgs.home.playersInFormation = args.home.playersInFormation.map((player) => ({
      ...player,
      imageUrl: hydrateImageUrl({
        url: player.imageUrl || '',
        hash: headshothash,
      }),
      fallbackImageUrl: hydrateImageUrl({
        url: player.fallbackImageUrl || '',
        hash: headshothash,
      }),
    }));
  }

  if (args?.away?.playersInFormation?.length) {
    hydratedArgs.away.playersInFormation = args.away.playersInFormation.map((player) => ({
      ...player,
      imageUrl: hydrateImageUrl({
        url: player.imageUrl || '',
        hash: headshothash,
      }),
      fallbackImageUrl: hydrateImageUrl({
        url: player.fallbackImageUrl || '',
        hash: headshothash,
      }),
    }));
  }

  return hydratedArgs;
};
